<dx-tab-panel [(selectedIndex)]="currentIndex">

  <dxi-item [title]="'Analyse par prestation'">
    <dx-data-grid
      #gridPrestation
      [dataSource]="analyseFinancierePrestation"
      [width]="'98%'"
      [showBorders]="true"
      [showColumnLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="true"
      [allowColumnResizing]="true"
      [rowAlternationEnabled]="true"
      [showRowLines]="true"
      columnResizingMode="widget">

      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 50, 100]"
      >
      </dxo-pager>
      <dxo-grouping
        [contextMenuEnabled]="true">
      </dxo-grouping>
      <dxo-state-storing
        [enabled]="true"
        type="localStorage"
        storageKey="facturesTableauDeBordAnalyseParPrestation">
      </dxo-state-storing>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-group-panel
        [visible]="true">
      </dxo-group-panel>
      <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
      <dxo-toolbar>
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">
          <div *dxTemplate>
            <yo-button
              [theme]="ButtonThemeEnum.ADD"
              iconClass="fas fa-search-dollar"
              label="Exporter l'analyse financière"
              (onClick)="displayExportSettings(currentIndex)"
              tooltip="Exporter l'analyse financière de vente">
            </yo-button>
          </div>
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
        <dxi-item name="columnChooserButton"></dxi-item>
        <dxi-item location="after" widget="dxButton" [options]="collapsePrestationOptions"></dxi-item>
        <dxi-item location="after" widget="dxButton" [options]="expandPrestationOptions"></dxi-item>
      </dxo-toolbar>
      <dxo-summary>
        <dxi-group-item column="effectifPrevisionnel" summaryType="sum" displayFormat="{0}" [alignByColumn]="true" [showInGroupFooter]="false"></dxi-group-item>
        <dxi-group-item column="effectifFabrique" summaryType="sum" displayFormat="{0}" [alignByColumn]="true" [showInGroupFooter]="false"></dxi-group-item>
        <dxi-group-item column="effectifFacture" summaryType="sum" displayFormat="{0}" [alignByColumn]="true" [showInGroupFooter]="false"></dxi-group-item>
      </dxo-summary>
      <dxi-column
        [allowHeaderFiltering]="true"
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="uniteProductionLibelle"
        caption="Unité de production">
      </dxi-column>
      <dxi-column
        [allowHeaderFiltering]="true"
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="pointDeFacturation"
        caption="Point de facturation">
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="pointDeLivraison"
        caption="Point de livraison"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="prestation"
        caption="Prestation"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="regime"
        caption="Régime"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="repas"
        caption="Repas"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="elementFacturableLibelle"
        caption="Élément facturable"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="dateMenu"
        caption="Date menu"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="effectifPrevisionnel"
        caption="Effectif prévisionnel"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="effectifFabrique"
        caption="Effectif fabriqué"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="effectifFacture"
        caption="Effectif facturé"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="margeReel"
        headerCellTemplate="margeReelHeader"
        caption="Marge réelle (en %)">
        <div *dxTemplate="let data of 'margeReelHeader'"
             title="Proportion de l'écart entre Prix de prestation et CM réél VS Prix de prestation">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerCellTemplate="rentabiliteReelHeader"
        dataField="rentabiliteReel"
        caption="Marge réelle (en montant)">
        <div *dxTemplate="let data of 'rentabiliteReelHeader'"
             title="Ecart entre CA Réél et CM Réel (Montant sorties validées)">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        cellTemplate="variationPercTemplate"
        headerCellTemplate="variationPercTemplateHeader"
        dataField="variationPerc"
        caption="Variation marge en %"
      ></dxi-column>
      <div *dxTemplate="let data of 'variationPercTemplateHeader'"
           title="Ecart entre marge prévue et réelle">
        {{ data.column.caption }}
      </div>

      <div *dxTemplate="let cell of 'variationPercTemplate'">
        <span
          [style.color]="cell.data.rentabiliteReel >= cell.data.rentabilitePrevisionnel ? 'var(--success-color)' : 'var(--error-color)'">{{ cell.value }}</span>
      </div>
    </dx-data-grid>

  </dxi-item>

  <dxi-item title="Analyse par famille de produit">
    <dx-data-grid
      #gridFamilleProduit
      [dataSource]="analyseFinanciereFamilleProduit"
      [width]="'98%'"
      [showBorders]="true"
      [showColumnLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="true"
      [allowColumnResizing]="true"
      [rowAlternationEnabled]="true"
      [showRowLines]="true"
      columnResizingMode="widget">>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 50, 100]">
      </dxo-pager>
      <dxo-grouping
        [contextMenuEnabled]="true">
      </dxo-grouping>
      <dxo-state-storing
        [enabled]="true"
        type="localStorage"
        storageKey="facturesTableauDeBordAnalyseParFamilleDeProduit">
      </dxo-state-storing>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-group-panel
        [visible]="true">
      </dxo-group-panel>
      <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
      <dxo-toolbar>
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">
          <div *dxTemplate>
            <yo-button
              [theme]="ButtonThemeEnum.ADD"
              iconClass="fas fa-search-dollar"
              label="Exporter l'analyse financière"
              (onClick)="displayExportSettings(currentIndex)"
              tooltip="Exporter l'analyse financière de vente">
            </yo-button>
          </div>
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
        <dxi-item name="columnChooserButton"></dxi-item>
        <dxi-item location="after" widget="dxButton" [options]="collapseFamilleProduitOptions"></dxi-item>
        <dxi-item location="after" widget="dxButton" [options]="expandFamilleProduitOptions"></dxi-item>
      </dxo-toolbar>
      <dxi-column
        [allowHeaderFiltering]="true"
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="uniteProductionLibelle"
        caption="Unité de production">
      </dxi-column>
      <dxi-column
        [allowHeaderFiltering]="true"
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="pointDeFacturation"
        caption="Point de facturation">
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="pointDeLivraison"
        caption="Point de livraison"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="prestation"
        caption="Prestation"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="regime"
        caption="Régime"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="repas"
        caption="Repas"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="familleProduit"
        caption="Famille de produit"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="dateMenu"
        caption="Date menu"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="margeReel"
        headerCellTemplate="margeReelHeader"
        caption="Marge réelle (en %)">
        <div *dxTemplate="let data of 'margeReelHeader'"
             title="Proportion de l'écart entre Prix du plat et CM réél VS Prix du plat">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerCellTemplate="rentabiliteReelHeader"
        dataField="rentabiliteReel"
        caption="Marge réelle (en montant)">
        <div *dxTemplate="let data of 'rentabiliteReelHeader'"
             title="Ecart entre CA Réél et CM Réel (Montant sorties validées)">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        cellTemplate="variationPercTemplate"
        headerCellTemplate="variationPercTemplateHeader"
        dataField="variationPerc"
        caption="Variation marge en %"
      ></dxi-column>
      <div *dxTemplate="let data of 'variationPercTemplateHeader'"
           title="Ecart entre marge prévue et réelle">
        {{ data.column.caption }}
      </div>

      <div *dxTemplate="let cell of 'variationPercTemplate'">
        <span [class]="cell.data.rentabiliteReel >= cell.data.rentabilitePrevisionnel ? 'rentable' : 'not-rentable'">{{ cell.value }}</span>
      </div>
    </dx-data-grid>

  </dxi-item>
  <dxi-item [title]="'Analyse par plat'">
    <dx-data-grid
      #gridPlat
      [dataSource]="analyseFinancierePlat"
      [width]="'98%'"
      [showBorders]="true"
      [showColumnLines]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="true"
      [allowColumnResizing]="true"
      [rowAlternationEnabled]="true"
      [showRowLines]="true"
      columnResizingMode="widget">
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 50, 100]">
      </dxo-pager>
      <dxo-grouping
        [contextMenuEnabled]="true">
      </dxo-grouping>
      <dxo-state-storing
        [enabled]="true"
        type="localStorage"
        storageKey="facturesTableauDeBordAnalyseParPlat">
      </dxo-state-storing>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-group-panel
        [visible]="true">
      </dxo-group-panel>
      <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
      <dxo-toolbar>
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">
          <div *dxTemplate>
            <yo-button
              [theme]="ButtonThemeEnum.ADD"
              iconClass="fas fa-search-dollar"
              label="Exporter l'analyse financière"
              (onClick)="displayExportSettings(currentIndex)"
              tooltip="Exporter l'analyse financière de vente">
            </yo-button>
          </div>
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
        <dxi-item name="columnChooserButton"></dxi-item>
        <dxi-item location="after" widget="dxButton" [options]="collapsePlatOptions"></dxi-item>
        <dxi-item location="after" widget="dxButton" [options]="expandPlatOptions"></dxi-item>
      </dxo-toolbar>
      <dxi-column
        [allowHeaderFiltering]="true"
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="uniteProductionLibelle"
        caption="Unité de production">
      </dxi-column>
      <dxi-column
        [allowHeaderFiltering]="true"
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="pointDeLivraison"
        caption="Point de livraison">
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="prestation"
        caption="Prestation"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="regime"
        caption="Régime"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="repas"
        caption="Repas"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="decoupageRepas"
        caption="Découpage repas"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="plat"
        caption="Plat"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        dataField="dateMenu"
        caption="Date menu"
      ></dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerFilter="ecartCMTheoriqueVsReelPercHeader"
        dataField="ecartCMTheoriqueVsReelPerc"
        caption="Ecart CM réel vs théorique (en %)">
        <div *dxTemplate="let data of 'ecartCMTheoriqueVsReelPercHeader'"
             title="Coût matière réél basé sur le montant des sorties validées VS Coût de revient théorique du menu">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerCellTemplate="margeReelHeader"
        dataField="margeReel"
        caption="Marge réelle (en %)">
        <div *dxTemplate="let data of 'margeReelHeader'"
             title="Proportion de l'écart entre Prix du plat et CM réél VS Prix du plat">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        headerCellTemplate="rentabiliteReelHeader"
        dataField="rentabiliteReel"
        caption="Marge réelle (en montant)">
        <div *dxTemplate="let data of 'rentabiliteReelHeader'"
             title="Ecart entre CA Réél et CM Réel (Montant sorties validées)">
          {{ data.column.caption }}
        </div>
      </dxi-column>
      <dxi-column
        [allowFiltering]="true"
        [allowSorting]="true"
        cellTemplate="variationPercTemplate"
        headerCellTemplate="variationPercTemplateHeader"
        caption="Variation marge en %"
        dataField="variationPerc"
      ></dxi-column>
      <div *dxTemplate="let data of 'variationPercTemplateHeader'"
           title="Ecart entre marge prévue et réelle">
        {{ data.column.caption }}
      </div>
      <div *dxTemplate="let cell of 'variationPercTemplate'">
        <span
          [style.color]="cell.data.rentabiliteReel >= cell.data.rentabilitePrevisionnel ? 'var(--success-color)' : 'var(--error-color)'">{{ cell.value }}
        </span>
      </div>
    </dx-data-grid>
  </dxi-item>
</dx-tab-panel>
<yo-analyse-financiere-export
  (currentIndexChange)="updateSelectedIndex($event)">
</yo-analyse-financiere-export>
